// ExtendExpireButton.jsx
import React, { useState } from 'react';
import { extendPartyExpireAtDeep } from '../firebaseClient';

export default function ExtendExpireButton({ code }) {
  const [busy, setBusy] = useState(false);

  const onClick = async () => {
    setBusy(true);
    try {
      const { expireAt } = await extendPartyExpireAtDeep({
        code,
        days: 7,
      });
      alert(`연장되었습니다.\n삭제 예정: ${new Date(expireAt).toLocaleString()}`);
      window.location.reload(); // ✅ 새로고침
    } catch (e) {
      console.error(e);
      alert(`실패: ${e?.message || e}`);
    } finally {
      setBusy(false);
    }
  };

  return (
      <button
        type="button"
        onClick={onClick}
        disabled={busy}
        className="btn btn-xs ml-auto"
        title="기간 연장"
      >
        {busy ? '연장 중…' : '연장하기'}
      </button>
  );
}
